const closeReasonList = [
    { value: "Lost on Price", label: "Lost on Price" },
    { value: "Change in itinerary", label: "Change in itinerary" },
    { value: "Trip Cancelled", label: "Trip Cancelled" },
    { value: "Duplicate", label: "Duplicate" },
    { value: "Price is over budget", label: "Price is over budget" },
    { value: "Incorrect contact details", label: "Incorrect contact details" },
    { value: "Test", label: "Test" },
    { value: "Flew Commercial", label: "Flew Commercial" },
    { value: "No response", label: "No response" },
    { value: "Cannot afford Private Jet", label: "Cannot afford Private Jet" },
    { value: "Lost Aircraft", label: "Lost Aircraft" },
    { value: "Aircraft AOG", label: "Aircraft AOG" },
    { value: "Lost to Competitor (Not on price)", label: "Lost to Competitor (Not on price)" },
    { value: "Platform Bug", label: "Platform Bug" },
];

const kycHeatList = [
    { value: "Hot", label: "Hot" },
    { value: "Medium", label: "Medium" },
    { value: "Speculative", label: "Speculative" },
    { value: "Redundant", label: "Redundant" },
    { value: "Duplicate", label: "Duplicate" },
    { value: "Staff", label: "Staff" },
];

const wifiList = [
    { value: "No WiFi Available", label: "No WiFi Available" },
    { value: "WiFi Available (Additional cost)", label: "WiFi Available (Additional cost)" },
    { value: "WiFi Included", label: "WiFi Included" },
];

const cateringList = [
    { value: "No Catering Included", label: "No Catering Included" },
    { value: "Snack Catering Included", label: "Snack Catering Included" },
    { value: "Light Catering Included", label: "Light Catering Included" },
    { value: "VIP Catering Included", label: "VIP Catering Included" },
];

const dealSourceList = [
    { value: "Data Mining / Research", label: "Data Mining / Research" },
    { value: "Existing Client", label: "Existing Client" },
    { value: "Existing Client Referral", label: "Existing Client Referral" },
    { value: "WealthX", label: "WealthX" },
    { value: "Giles / Scott Referral", label: "Giles / Scott Referral" },
    { value: "Reengaged Client", label: "Reengaged Client" },
    { value: "3rd Party Referral", label: "3rd Party Referral" },
    { value: "Ambassador Referral", label: "Ambassador Referral" },
    { value: "Chat AI", label: "Chat AI" },
    { value: "Personal Contact", label: "Personal Contact" },
    { value: "Website", label: "Website" },
    { value: "Enquiry to Fly@SHY", label: "Enquiry to Fly@SHY" },
    { value: "White Label Partner", label: "White Label Partner" },
    { value: "Incoming call", label: "Incoming call" },
    { value: "Lifestyle Referral", label: "Lifestyle Referral" },
    { value: "Test", label: "Test" },
    { value: "Networking Event", label: "Networking Event" },
    { value: "Social Media", label: "Social Media" },
    { value: "Zoominfo", label: "Zoominfo" },
];

const yesNoList = [
    { value: "No", label: "No" },
    { value: "Yes", label: "Yes" },
];

const portalFilterOptions = [
    { value: "all", label: "All" },
    { value: "Mine", label: "My deals" },
    { value: "Shy", label: "SHY deals" },
    { value: "Jetsphere", label: "JetSphere deals" },
];

const commercialRepOptions = [
    "Nipun Sathyapala",
    "Shokh Iskandarov",
    "Max Haynes",
    "Bianca Lucas",
    "Josh Sherratt",
];

const commercialRepIdsByEnv = {
    production: {
        "Nipun Sathyapala": "2249055000174899006",
        "Shokh Iskandarov": "2249055000093432001",
        "Max Haynes": "2249055000217726001",
        "Bianca Lucas": "2249055000258672001",
        "Josh Sherratt": "2249055000270898001",
    },
    sandbox: {
        "Nipun Sathyapala": "5034369000174899006",
        "Shokh Iskandarov": "5034369000093432001",
        "Max Haynes": "5034369000217726001",
        "Bianca Lucas": "5034369000257094007",
        "Josh Sherratt": "5034369000258746001",
    },
};

const isLiveHost =
    typeof window !== "undefined" && /(^|\.)shyaviation\.com$/i.test(window.location.hostname);

const commercialRepIds = isLiveHost ? commercialRepIdsByEnv.production : commercialRepIdsByEnv.sandbox;

export {
    closeReasonList,
    kycHeatList,
    wifiList,
    cateringList,
    dealSourceList,
    yesNoList,
    portalFilterOptions,
    commercialRepOptions,
    commercialRepIds,
};
